const rootPath = '..';

const loadImage = (path: string): string => {
    if (path.startsWith('@/')) {
        path = path.replace('@', rootPath);
        return new URL(path, import.meta.url).href;
    }

    return path;
}

export {
    loadImage,
}
